export enum MyProjectsTableRowActionEnum {
    'EDIT',
    'COPY',
    'HISTORY',
    'DELETE',
    'DOWNLOAD_OFFER_PDF',
    'EDIT_SUMMARY_PAGE',
    'PROJECT_NAME_LINK_CLICKED',
    'PRICE_APPROVAL',
    'PRICE_APPROVAL_TABLE_PROJECT_NAME_LINK_CLICKED',
    'TCO_CALCULATION'
}
